var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"landing-app"}},[_c('ThreeBackground'),_c('StepLayout',{attrs:{"current-step":_vm.currentStep,"total-steps":_vm.totalSteps,"form-data":_vm.formData,"validation-message":_vm.validationMessage},on:{"next":_vm.nextStep,"prev":_vm.prevStep,"go-to":_vm.goToStep,"submit":_vm.submitForm,"update-form":_vm.updateForm}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }